/**
 * Pylon Chat Widget - client-only plugin
 *
 * Injects the Pylon script directly into the document to avoid Nuxt 4 / Unhead v2
 * head management issues (Capo.js tag sorting, useHead script handling).
 * Chat settings (email, name) are set in app.vue when the user is authenticated.
 *
 * @see https://docs.usepylon.com/pylon-docs/chat-widget/chat-setup
 */
import {defineNuxtPlugin} from '#app';

const PYLON_APP_ID = '2e6349d2-09e8-49ee-8756-656cf20a7c8c';

export default defineNuxtPlugin(() => {
  if (typeof window === 'undefined') return;

  const isDev =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname.includes('.local');

  if (isDev) return;

  const script = document.createElement('script');
  script.textContent = `(function(){var e=window;var t=document;var n=function(){n.e(arguments)};n.q=[];n.e=function(e){n.q.push(e)};e.Pylon=n;var r=function(){var e=t.createElement("script");e.setAttribute("type","text/javascript");e.setAttribute("async","true");e.setAttribute("src","https://widget.usepylon.com/widget/${PYLON_APP_ID}");var n=t.getElementsByTagName("script")[0];n.parentNode.insertBefore(e,n)};if(t.readyState==="complete"){r()}else if(e.addEventListener){e.addEventListener("load",r,false)}})();`;
  document.head.appendChild(script);
});
